///include /assets/js/plugins/dac-parts.js
///include /assets/js/plugins/components/custom-radio.js

"use strict"

const DomainSearch = Vue.extend({
    delimiters: ["[[", "]]"],
    name: "CategoryDomainSearch",
    props: {
        defaultYears: {
            type: Number,
            required: false,
            default: 2,
        },
        option: {
            type: String,
            required: false,
            default: 'register',
        },
        search: {
            type: [PointerEvent, null],
            required: false,
            default: null
        },
        searchQuick: {
            type: [Event, null],
            required: false,
            default: null
        },
        domainRequired: {
            type: Boolean,
            required: false,
            default: false
        },
        singleDomain: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        const vue = this
        return {
            basketClient: AnyBasket.inst,
            /** @type {AnyDomainStore} */
            domainStore: AnyDomainStore.inst,
            /** @type {?string} */
            expandedDomainSearchDomain: null,
            filters: [],
            initialBuild: false,
            initialSearch: null,
            initialDomains: [
                ".co.uk",".com",".uk",".org.uk",".net",".org",".co",".info",".me.uk",".online"
            ],
            /** @type {?XMLHttpRequest} */
            lastRequest: null,
            /** @type {?NodeJS.Timeout} */
            lookupWait: null,
            maxPrice: 0.00,
            maxPriceDebounceTimeout: null,
            maxPriceRemovesRemainder: false,
            multiSearch: false,
            searchBarValue: "",
            /** @type {DomainResult[]} */
            searchResults: [],
            selectedCategory: ["Popular"],
            selectedsingleCategory: null,
            showAvailable: "all",
            sortByOptions: [
                { id: 'recommended', text: 'Recommended' },
                { id: 'domain', text: 'Alphabetical' },
                { id: 'price', text: 'Price (low to high)' }
            ],
            availableOptions: [
                { id: 'all', text: 'All' },
                { id: 'register', text: 'Available' },
                { id: 'transfer', text: 'Taken' },
            ],
            /** @type {?string} */
            sortOrder: 'recommended',
            /** @type {?boolean} */
            startLoadedSearchDone: null,
            /** @type {string[]} */
            undeleted: [],
            // ? Not sure why this is here - doesn't seem to be set..
            user: null,
            // ..create a separate one instead
            userInst: User.inst,
            async toggle_brandProtect_basket() {
                for( var d of this.brandProtectDomains ){
                    d.selected_years = this.inauguralDomain.selected_years;
                    if( !d.basketItem ){
                        var f = await d.addToBasket(true);
                    }
                }
            },
            get addBrandDomainsStatus() {
                var basket = 0;
                for( var d of this.brandProtectDomains ){
                    if( d.status.in_basket ){
                        basket++;
                    }
                }
                return basket == this.brandProtectDomains.length ? "in_basket" : "";
            },
            get brandProtectDomains() {
                var allowedBrandDomains = [".uk",".co.uk",".com",".org",".net","online"];
                if( this.searchResults && this.inauguralDomain && this.inauguralDomain.status.can.match(/register/) ){
                    var possible = this.searchResults.filter( (r) => {
                        if( r.name == this.inauguralDomain.name || (r.status && r.status.can && !r.status.can.match(/register/)) ){
                            // We dont want the domain they searched for. Or domains that cannot be registered
                            return false;
                        }
                        return allowedBrandDomains.includes(r.tld);
                    } );

                    return possible.sort( (a,b) => {
                        return allowedBrandDomains.indexOf(a.tld) - allowedBrandDomains.indexOf(b.tld);
                    } ).splice(0,3);
                } else {
                    return [];
                }
            },
            get brandProtectDomainOptions() {
                var options = [];

                var validYears = [];
                for( var year = 1; year <= 10; year++ ){
                    var valid = true;
                    for( var d of this.brandProtectDomains ){
                        if( !this.domainStore.yearsByTld[d.tld].includes(year) ){
                            valid = false;
                        }
                    }
                    if( valid ){
                        validYears.push(year);
                    }
                }


                for(var year of validYears) {
                    var totalDomainPrice = 0.00;
                    for( var d of this.brandProtectDomains ){
                        var yearlyPrice;
                        if( this.domainStore.userInfo && this.domainStore.userInfo.isReseller ){
                            yearlyPrice = parseFloat(this.domainStore.productByTld[d.tld].pricing.card.yearly.reseller.purchase);
                        } else {
                            yearlyPrice = parseFloat(this.domainStore.productByTld[d.tld].pricing.card.yearly.non_reseller.purchase);
                        }
                        totalDomainPrice+= yearlyPrice * year;
                    }
                    options.push({
                        text: year + " " + (year > 1 ? "years" : "year") + " for " + this.basketClient.currencySymbol + parseFloat(totalDomainPrice).toFixed(2),
                        id: year
                    });
                }
                return options;
            },

            get basketSubTotalBeforeTax() {
                if (!this.basketClient || !this.basketClient.items) {
                    return null
                }

                return `${this.basketClient.currencySymbol}${this.basketClient.content['total-excluding-vat']}`
            },

            /** @type {boolean} */
            get can_select_all() {
                return this.domainList.some(
                    d => d.mayAddToBasket
                )
            },
            /** @type {?string[]} */
            get categorylist() {
                if (!this.domainCategory) {
                    return null
                }

                const categories = Object.keys(this.domainCategory).sort()
                const hasPopular = categories.indexOf('Popular')
                const hasNew = categories.indexOf('New')

                if (hasNew) {
                    categories.splice(hasNew, 1)
                    categories.unshift('New')
                }

                if (hasPopular) {
                    categories.splice(hasPopular, 1)
                    categories.unshift('Popular')
                }

                return categories
            },
            /**
             * @type {boolean}
             */
            get checked_domains() {
                return this.domainList.some(d => d.status.checked)
            },
            /**
             * @type {boolean}
             */
            get contactFormAvailable() {
                //@ts-ignore
                const brand = window.brand
                return brand && brand.togglePrefs && brand.togglePrefs.contactForm
            },
            get domainCategory() {
                return this.domainStore instanceof DomainStore ? domain_categories(this.basketClient.currency) : this.domainStore.domainCategory
            },
            get notHiddenSearchResults() {
                return this.searchResults.filter(r => !r.hidden)
            },
            get domainList() {
                /** @type {DomainResult[]} */
                let domainsInView = []
                if(this.multiSearch) {
                    domainsInView.push(...this.inUseSearchResults)
                } else {
                    const parts = this.searchBarValue.split(".")[0]
                    for(const tld of this.expandedTldsFromCategories) {
                        const result = this.inUseSearchResults.find(
                            result => (
                                parts == result.nameWithoutTld &&
                                result.name.toLowerCase().replace(
                                    /^[^.]*/,
                                    ""
                                ) == tld
                            )
                        )
                        if(result) {
                            domainsInView.push(result)
                        }
                    }
                }

                switch(this.showAvailable) {
                    case "all":
                        break
                    case "transfer":
                        domainsInView = domainsInView.filter(
                            d => d.status.can && d.status.can.match(/transfer/)
                        )
                        break
                    default:
                        domainsInView = domainsInView.filter(d => (
                            d.status.can &&
                            d.status.can == this.showAvailable
                        ))
                        break
                }

                if(this.maxPrice > 0) {
                    const start = domainsInView.length
                    domainsInView = domainsInView.filter(d => (
                        d.pricingOptions &&
                        d.pricingOptions.length &&
                        d.status instanceof DRStatus &&
                        d.status.oneYearPrice !== null &&
                        (d.status.oneYearPrice < +this.maxPrice)
                    ))
                    if(start > 0 && !domainsInView.length) {
                        this.maxPriceRemovesRemainder = true
                    }
                }

                return domainsInView.sort((a, b) => {
                    switch(this.sortOrder) {
                        case "price":
                            const aTLD = a.name.replace(/^[^.]*/, "")
                            const bTLD = b.name.replace(/^[^.]*/, "")
                            /**
                             *
                             * @param {SBDomainProduct|DACDomainProduct} p
                             */
                            function _p(p) {
                                if((typeof SBDomainProduct !== 'undefined') && (p instanceof SBDomainProduct)) {
                                    for(const v of p.pricing) {
                                        if(v.periodMonths == 12) {
                                            return v.price || 0
                                        }
                                    }
                                    return 0
                                } else {
                                    return p.anyPrice.purchase
                                }
                            }

                            function filterObject(obj, callback) {
                                return Object.fromEntries(Object.entries(obj).
                                  filter(([key, val]) => callback(val, key)))
                            }

                            /**
                             * Filter out hidden products when dealing with hostshop
                             */
                            const product_by_tld = (typeof SDomainStore !== 'undefined') && (a.domainStore instanceof SDomainStore) ?
                                filterObject(this.domainStore.productByTld, p => !p.hidden) :
                                this.domainStore.productByTld

                            if(product_by_tld && product_by_tld[aTLD]) {
                                return(
                                    _p(product_by_tld[aTLD]) -
                                    _p(product_by_tld[bTLD])
                                )
                            } else {
                                return 0
                            }
                        case "domain":
                            return a.name.localeCompare(b.name)
                        default:
                            // keep existing order
                            return 0
                    }
                })
            },
            // For compat
            get domains() {
                return this.searchResults
            },
            /** @type {string[]} */
            get expandedTldsFromCategories() {
                const tld = []
                for(const c of this.selectedCategory) {
                    if(this.domainCategory && this.domainCategory[c]) {
                        tld.push(...this.domainCategory[c])
                    }
                }
                return tld
            },
            /** @type {boolean} */
            get hasReseller() {
                return this.domainStore && this.domainStore.userInfoGeneral && this.domainStore.userInfoGeneral.isReseller
            },
            /** @type {?DomainResult | undefined} **/
            get inauguralDomain() {
                return this.inUseSearchResults.find(
                    r => r.name == this.searchBarValue
                )
            },
            get inUseSearchResults() {
                return this.queryTld ? this.tldRestrictedSearchResults : this.notHiddenSearchResults
            },
            get noResults() {
                return this.searchBarValue && !this.searchInProgress
            },
            get parseQuery() {
                const query = window.location.search.substr(1).split('&')

                if (!query) return null

                /**
                 * @type {{ tld: string }}
                 */
                const queryObj = query.reduce((result, q) => {
                    const qParts = q.split('=')
                    result[qParts[0]] = qParts[1]
                    return result
                }, {})

                return { query, queryObj }
            },
            get searching() {
                return(
                    (this.searchInProgress && !this.domainList.length) ||
                    this.searchBarValue &&
                    this.showAvailable == "all" &&
                    !this.maxPriceRemovesRemainder
                )
            },
            get searchInProgress() {
                return this.searchResults.some(
                    r => !r.status.response
                )
            },

            /**
             * @type {boolean}
             */
            get selected_all_domains() {
                return !this.domainList.filter(
                    domain => domain.mayAddToBasket
                ).some(domain => !domain.status.checked)
            },
            set selected_all_domains(v) {
                if(v) {
                    this.domainList.filter(
                        domain => domain.mayAddToBasket
                    ).forEach(domain => {
                        domain.status.checked = true
                    })

                } else {
                    this.domainList.forEach(domain => {
                        domain.status.checked = false
                    })
                }
            },
            get tldRestrictedSearchResults() {
                return this.searchResults.filter(r => r.name.indexOf(this.queryTld) !== -1)
            },

            get queryTld() {
                if (!this.parseQuery || !this.parseQuery.queryObj) return null

                const { queryObj: { tld } } = this.parseQuery

                return tld
            },

            get isGovUkDomain() {
                if(/\.gov\.uk$/.test(this.inauguralDomain.name)){
                    return true
                }
                return false
            },

            get isSchUkDomain() {
                if(/\.sch\.uk$/.test(this.inauguralDomain.name)){
                    return true
                }
                return false
            },

            /**
             * When clicking "Add selected domains to basket" button
             *
             * @param {boolean} [silent]
             */
            async add_domains_to_basket(silent = false) {
                const fd = this.domainList.filter(
                    domain => domain.status.checked
                )

                for(const domain of fd) {
                    await domain.addToBasket(silent)
                }
                this.basketClient.reloadContent(silent)
            },
            /**
             *
             * @param {DomainResult} domain
             * @returns {boolean}
             */
            canBasket(domain) {
                return !domain.status.in_basket && !domain.status.disableLock
            },
            /**
             *
             * @param {DomainResult} domain
             * @returns {?boolean}
             */
            canSelectYears(domain) {
                return(
                    this.canBasket(domain) &&
                    domain.status.connected_to_registrar &&
                    !domain.status.disabled &&
                    domain.status.can_class != "unsupported"
                )
            },
            /**
             *
             * @param {DomainResult} domain
             * @returns {boolean}
             */
            disabledButton(domain) {
                return(
                    (!domain.status.connected_to_registrar) ||
                    domain.loading_data ||
                    domain.status.disabled ||
                    !domain.pricingOptions.length
                )
            },
            formatDomainPricing(state) {
                if (!state.id) {
                    return state.text
                  }

                  const splitText = state.text.split('for ')
                  const stitchedText = `<span style="display: inline-block; width: 100%; text-align: center;">${splitText[0]} <strong>${splitText[1]}</strong></span>`

                  return $(stitchedText)
            },
            /**
             * @param {string} availType
             * @returns {number?}
             */
            getAvailabilityCount(availType) {
                if (!this.searchBarValue) return null

                if (availType === 'all') {
                    return this.domains.length
                }

                const filteredDomains = this.domains.filter(dom => {
                    if (availType === 'transfer') {
                        return dom._status._can === 'transfer?' || dom._status._can === 'transfer'
                    } else if (availType === 'register') {
                        return dom._status._can === 'register'
                    }
                })

                return filteredDomains.length
            },
            /**
             * @param {string} cat The category name
             * @return {number}
             */
            getCategoryCount(cat) {
                if((typeof DomainStore !== 'undefined') && (this.domainStore instanceof DomainStore)) {
                    if(this.domainCetegoryCountsByPrice[cat]) {
                        const total = this.domainCetegoryCountsByPrice[cat].length
                        if(total > 0 && !this.selectedsingleCategory) {
                            this.selectedsingleCategory = cat
                        }
                        return total
                    }

                    return 0
                } else {
                    const product_by_tld = this.domainStore.productByTld
                    if(product_by_tld) {
                        var total = this.domainCategory[cat].filter(
                            d => !!product_by_tld[d]
                        ).length
                        if( total > 0 && !this.selectedsingleCategory ){
                            this.selectedsingleCategory = cat;
                        }
                        return total;
                    } else {
                        return 0
                    }
                }
            },
            /**
             * @param {KeyboardEvent} e
             */
            performSearchQuick(e) {
                if(this.lookupWait) {
                    clearTimeout(this.lookupWait)
                }

                switch(e.keyCode) {
                    case 13:
                        // Enter - lets search
                        this.performSearch()
                        break
                    case 189:
                    case 190:
                        // Do nothing if its a full stop or hyphen
                        break
                    default:
                        this.lookupWait = setTimeout(
                            () => this.performSearch(),
                            300
                        )
                }
            },
            /**
             * @param {boolean} [suggestions]
             * @param {?string} [search_term] If supplied, this will set the value
             * to search for
             */
            performSearch(search_term = null) {
                // Prevent this from ever being Caps
                if( this.searchBarValue != "" ){

                    var dmString = this.searchBarValue.toLowerCase()

                    var tString = function(string) {
                        while(string.charAt(0)=='-') {
                            string = string.substring(1);
                        }

                        while(string.charAt(string.length-1)=='-') {
                            string = string.substring(0,string.length-1);
                        }

                        return string;
                    }

                    this.searchBarValue = tString(dmString) // this.searchBarValue.toLowerCase()
                }

                if(!search_term) {
                    search_term = this.searchBarValue.toLowerCase()
                }
                if( search_term == "" ){
                    return
                }
                if(search_term.match(/^\s*[a-zA-Z0-9.\r\n,-]*$/)) {
                    search_term = search_term.replace(
                        /(\r?\n)+/g,
                        ","
                    ).replace(
                        /^[^a-zA-Z0-9]*/,
                        ""
                    ).toLowerCase()
                } else {
                    search_term = this.searchBarValue.toLowerCase()
                }

                search_term = this.sanitiseSearchTerm(search_term);

                var searchMatchesDomain = false
                var compiledSearchTerm
                var tldToSearch
                if( !search_term.match(/[a-z0-9][.][a-z]/) ){
                    if(this.expandedDomainSearchDomain != search_term) {
                        this.expandedDomainSearchDomain = search_term
                        this.searchResults = []
                    }
                    var done = {}
                    this.searchResults.forEach( (r) => {
                        done[r.name] = true
                    } )
                    tldToSearch = this.expandedTldsFromCategories.filter(
                        tc => (
                            done[search_term + tc] == undefined &&
                            this.domainStore.productByTld &&
                            !!this.domainStore.productByTld[tc]
                        )
                    )
                    if(tldToSearch.length) {
                        compiledSearchTerm =
                            search_term + "," + tldToSearch.join(",")
                    } else {
                        return // Nothing to search for
                    }
                } else {
                    if( search_term.match(/,/) ){
                        searchMatchesDomain = false
                        this.multiSearch = true
                    } else {
                        this.multiSearch = false
                        searchMatchesDomain = true
                    }
                    compiledSearchTerm = search_term
                }

                if(this.lookupWait) {
                    clearTimeout(this.lookupWait)
                }
                this.lookupWait = null
                if(this.lastRequest) {
                    this.lastRequest.abort()
                }

                // ...
                // jQuery does not actually support incremental load!
                let xhr = new XMLHttpRequest()

                xhr.onabort = () => {
                    var aborted = []
                    if( tldToSearch && tldToSearch.length ){
                        tldToSearch.forEach( (tld) => {
                            let result = this.searchResults.find(
                                result => result.name.toLowerCase() ==
                                    (search_term+tld).toLowerCase()
                            )
                            if( result && result.status.constructor.name != "DRStatus" ){
                                aborted.push( search_term+tld )
                            }
                        } )
                        this.searchResults = this.searchResults.filter( r => !aborted.includes(r.name) )
                    }
                }

                let read_to_offset = 0
                xhr.onprogress = event => {
                    if(read_to_offset < xhr.responseText.length) {
                        var res = {}
                        if(this.basketClient.itemsFlat) {
                            this.basketClient.itemsFlat.filter(
                                i => i.serviceType == "domain"
                            ).forEach(bi => res[bi.identity.toLowerCase()] = bi)
                        }

                        let buffer = xhr.responseText.substring(read_to_offset)
                        buffer.split(/(\n)/).forEach(part => {
                            if(part.match(/^[\n\[\],]?$/)) {
                                read_to_offset += part.length
                            } else if(part.match(/^{.*}$/)) {
                                let p = JSON.parse(part)
                                if(p.header) {
                                    p.header.names.forEach( (r) => {
                                        let result = this.searchResults.find(
                                            result => result.name.toLowerCase() ==
                                                r.toLowerCase()
                                        )
                                        if( !result ){
                                            var nr = new DomainResult(
                                                r,
                                                this.domainStore,
                                                this.basketClient,
                                                this.defaultYears
                                            )
                                            if( res[r] ){
                                                nr.basketItem = res[r]
                                                nr.selected_years = nr.basketItem.periodMonths / 12
                                            } else {
                                                nr.basketItem = null
                                            }
                                            this.searchResults.push(nr)
                                        }
                                    })
                                } else if(p.name) {
                                    let result = this.searchResults.find(
                                        result => result.name.toLowerCase() ==
                                            p.name.toLowerCase()
                                    )

                                    if(result) {
                                        try {
                                            result.status = new DRStatus(
                                                p,
                                                this.domainStore,
                                                this.basketClient
                                            )
                                            if( res[p.name] ) {
                                                result.status.in_basket = true
                                            }
                                            vue.$nextTick( () => {
                                                $(`[data-toggle="tooltip"]`).tooltip()
                                            } )
                                        } catch(e) {
                                            console.log(e)
                                            console.log(
                                                `Exception when handling ${p.name}`
                                            )
                                        }
                                    } else {
                                        if(p.can == "suggestion") {
                                            this.searchResults[p.name] = new DomainResult(
                                                p.name,
                                                this.domainStore,
                                                this.basketClient,
                                                this.defaultYears
                                            )
                                        } else {
                                            console.log(
                                                `Name ${p.name} is not in the search set`
                                            )
                                        }
                                    }
                                }
                                read_to_offset += part.length
                            } else {
                                console.log(part)
                            }
                        })
                    }
                }
                xhr.onload = (event) => {
                    if(xhr.status == 429) {
                        alert("Too many searches, please contact support")
                    } else if( searchMatchesDomain ){
                        this.expandedDomainSearchDomain = search_term.replace(/[.].*/, "")
                        this.performSearch( this.expandedDomainSearchDomain )
                    }
                }
                const searchTermEncoded = encodeURIComponent(compiledSearchTerm)
                let args
                if(search_term.match(/[a-z0-9][.][a-z]/)) {
                    args = {
                        noexpand: +true,
                    }
                } else if(compiledSearchTerm.match(/[a-z0-9][.][a-z]/)) {
                    args = {
                        detailed: +false,
                        noexpand: +true,
                    }
                } else {
                    args = {
                        detailed: +false,
                    }
                }
                xhr.open(
                    "GET",
                    `${appPrefix}/a/domain-search/${searchTermEncoded}?` +
                        $.param({
                            ...args
                        })
                )
                this.lastRequest = xhr
                xhr.send()
            },
            resetFilters() {
                this.sortOrder = 'recommended'
                this.showAvailable = "all"
                this.maxPrice = 0.00

                // v-model not used for max price instead v-on:input
                // in order to implement debounce :| Got to update input manually
                const el = document.getElementById('maxPrice')
                if(el) {
                    el.value = ""
                }

            },

            sanitiseSearchTerm(searchTerm) {
                // Simple sanitise to prevent infinate loading
                // We may in the future want to compile a new list of
                // domains and search eg "foo.co.uk,f-o-o.co.uk"

                // Remove any spaces ' '
                var searchTermResult = searchTerm.replace(/ /g,"");

                // Remove any + sign
                searchTermResult = searchTermResult.replace(/\+/g,"");

                // Set the search bar to match, without this nothing shows
                if( searchTermResult != searchTerm ){
                    this.searchBarValue = searchTermResult;
                }
                return searchTermResult;
            },

            // Note if there is no search term in the URL this does nothing!
            startLoadedSearch(){
                if( !this.startLoadedSearchDone ){
                    this.startLoadedSearchDone = true
                    let md
                    if(md = location.search.match(/[?&;]domain=([^&;=]+)/)) {
                        this.searchBarValue = this.sanitiseSearchTerm( decodeURIComponent(md[1].toLowerCase()) )
                        this.performSearch()
                    }
                }
            },

            /**
             *
             * @param {DomainResult} domain
             * @param {boolean} [silent]
             */
            async toggle_domain_basket(domain, silent = false) {
                if(domain.basketItem) {
                    return await this.basketClient.removeItem(domain.basketItem)
                } else if(domain.mayAddToBasket) {
                    domain.status.checked = false
                    if(domain.status.needsDetailCheck) {
                        await new Promise(
                            resolve => domain.checkDetailed(resolve)
                        )
                    }
                    await domain.addToBasket(silent)
                    await this.add_domains_to_basket(silent)
                }
            },

            /**
             * @param {string} so The sort order
             */
            togglesortOrder(so) {
                if( this.sortOrder != so ){
                    this.sortOrder = so
                } else {
                    this.sortOrder = null
                }
            },

            /**
             *
             * @param {DomainResult} domain
             */
            async undelete(domain) {
                const result = await this.domainStore.undelete(domain.name)
                if(result) {
                    this.undeleted.push(domain.name)
                }
            },

            updateShowAvailable(value) {
                vue.showAvailable = value
            },

            updateSelectedSingleCategory(value) {
                vue.selectedsingleCategory = value
            }
        }
    },
    methods: {
        formatResults: function (option) {
            return $(`<span>${option.text} <small>(${option.count})</small></span>`)
        },
        setMaxPrice(e) {
            const v = e.target.value
            if(v && v !== "") {
                if(this.maxPriceDebounceTimeout) {
                    clearTimeout(this.maxPriceDebounceTimeout)
                }
                this.maxPriceDebounceTimeout = setTimeout(() => {
                    this.maxPrice = v
                }, 600)
            } else {
                if(this.maxPriceDebounceTimeout) clearTimeout(this.maxPriceDebounceTimeout)
                this.maxPrice = 0.00
            }
        }
    },
    computed: {
        agencyHubNoReseller() {
            return (this.userInst.hasAgencyHub && !this.userInst.hasReseller);
        },
        categoryListOptions() {
            return this.categorylist ? this.categorylist.map(c => {
                return { id: c, text: c, count: this.getCategoryCount(c) }
            }).filter(c => c.count > 0) : []
        },
        domainCategoryPriceMap() {
            /** This does not need to be computed */
            if((typeof DomainStore !== 'undefined') && (this.domainStore instanceof DomainStore)) {
                const out = {}
                for(const c in this.domainCategory) {
                    out[c] = this.domainCategory[c].map(el => {
                        if(this.domainStore && this.domainStore.productByTld && this.domainStore.productByTld[el]) {
                            return {
                                tld: el,
                                price: this.domainStore.productByTld[el].anyPrice
                            }
                        }
                    }).filter(el => el !== undefined)
                }

                return out
            }
        },
        domainCetegoryCountsByPrice() {
            if(this.maxPrice) {
                const out = {}

                for(const c in this.domainCategoryPriceMap) {
                    out[c] = this.domainCategoryPriceMap[c].filter(el => el.price.purchase <= this.maxPrice)
                }

                return out
            }

            return this.domainCategoryPriceMap
        },
    },
    watch: {
        search(v) {
            this.performSearch()
        },
        searchQuick(v) {
            this.searchBarValue = v.target.value
            this.performSearchQuick(v)
        },
        "basketClient.itemsFlat": function(v) {
            if(v) {
                v = v.filter(i => i)
                const res = {}
                for(const bi of v) {
                    res[bi.identity.toLowerCase()] = bi
                }
                for(const dr of this.searchResults) {
                    if(res[dr.name.toLowerCase()]) {
                        dr.basketItem = res[dr.name.toLowerCase()]
                        dr.selected_years = dr.basketItem.periodMonths / 12
                        dr.status.in_basket = true
                    } else if (dr.status) {
                        dr.basketItem = null
                        dr.status.in_basket = false
                    }
                }
            }
        },
        "domainStore.productByTld": function(v){
            if(v && this.domainCategory){
                this.startLoadedSearch()
                if( !this.initialBuild ){
                    this.initialBuild = true
                    var allDomains = []
                    Object.keys(this.domainCategory).forEach( (key) => {
                        this.domainCategory[key].forEach( (d) => {
                            if( !allDomains.includes(d) ){
                                allDomains.push(d)
                            }
                        } )
                        if( key != "Popular" && key != "New" ){
                            this.domainCategory[key].sort()
                        }
                    } )
                    Object.keys(v).forEach( (tld) => {
                        if( !allDomains.includes(tld) ){
                            this.domainCategory["New"].push(tld)
                        }
                    } )
                }
            }
        },
        selectedCategory() {
            this.performSearch()
        },

        selectedsingleCategory(n) {
            if(n) {
                this.selectedCategory = [n]
            }
        },
    },
    components: {
        vueSelect: VueSelect,
        customRadio: CustomRadio
    },
    mounted() {
        this.domainStore.preload([
            "productByTld",
            "transferProductByTld",
            "userInfoGeneral",
            "yearsByTld"
        ])

        $(document).on("hashchange", () => this.performSearch())
    },
})

// This is DEPRECATED. Once www no longer needs it, it gets dropped.
Vue.component("domain-search", DomainSearch)
